import { serviceRequestConstants } from "../_constants";

export const serviceRequestTemplateCategoriesListRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_REQUEST,
    payload,
  };
};

export const serviceRequestTemplateCategoriesListComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_COMPLETE,
    payload,
  };
};

export const serviceRequestTemplateCategoriesListError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_CATEGORIES_LIST_ERROR,
    payload,
  };
};

export const serviceRequestListRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_LIST_REQUEST,
    payload,
  };
};

export const setServiceRequestIsPaginatingAssetOptions = (
  asset,
  isPaginating,
) => ({
  type: serviceRequestConstants.SET_IS_PAGINATING_ASSET_OPTIONS,
  payload: { asset, isPaginating },
});

export const serviceRequestListComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_LIST_COMPLETE,
    payload,
  };
};

export const serviceRequestListError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_LIST_ERROR,
    payload,
  };
};

export const setIsPaginatingServiceRequestList = (payload) => {
  return {
    type: serviceRequestConstants.SET_IS_PAGINATING_SERVICE_REQUEST_LIST,
    payload,
  };
};

export const serviceRequestTemplateListRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_LIST_REQUEST,
    payload,
  };
};

export const serviceRequestTemplateListComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_LIST_COMPLETE,
    payload,
  };
};

export const serviceRequestTemplateListError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_LIST_ERROR,
    payload,
  };
};

export const clearServiceRequestCategory = (payload) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST_CATEGORY,
    payload,
  };
};
export const setServiceRequestCategory = (payload) => {
  return {
    type: serviceRequestConstants.SET_SERVICE_REQUEST_CATEGORY,
    payload,
  };
};

export const setServiceRequestTemplate = (payload) => {
  return {
    type: serviceRequestConstants.SET_SERVICE_REQUEST_TEMPLATE,
    payload,
  };
};

export const setServiceRequestInitiateData = (payload) => {
  return {
    type: serviceRequestConstants.SET_SERVICE_REQUEST_INITIATE_DATA,
    payload,
  };
};

export const setServiceRequestFromExternal = (payload) => {
  return {
    type: serviceRequestConstants.SET_SERVICE_REQUEST_FROM_EXTERNAL,
    payload,
  };
};

export const clearServiceRequestFromExternal = (payload) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST_FROM_EXTERNAL,
    payload,
  };
};

export const clearServiceRequestInitiateData = (payload) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST_INITIATE_DATA,
    payload,
  };
};

export const clearServiceRequest = (payload) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST,
    payload,
  };
};

export const clearServiceRequestFieldList = (payload) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST_TEMPLATE_FIELDS,
    payload,
  };
};

export const serviceRequestTemplateFieldsRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_REQUEST,
    payload,
  };
};

export const serviceRequestTemplateFieldsComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_COMPLETE,
    payload,
  };
};

export const serviceRequestTemplateFieldsError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_TEMPLATE_FIELDS_ERROR,
    payload,
  };
};

export const serviceRequestAssetsOptionsRequest = (payload, meta) => {
  const action = {
    type: serviceRequestConstants.SERVICE_REQUEST_ASSETS_OPTIONS_REQUEST,
    payload,
  };

  if (meta && Object.keys(meta).length > 0) {
    action.meta = meta;
  }

  return action;
};

export const serviceRequestAssetsOptionsComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_ASSETS_OPTIONS_COMPLETE,
    payload,
  };
};

export const serviceRequestAssetsOptionsError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_ASSETS_OPTIONS_ERROR,
    payload,
  };
};

export const clearServiceRequestAssetOption = (assetKey) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST_ASSET_OPTION,
    payload: assetKey,
  };
};

export const serviceRequestValidateRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_VALIDATE_REQUEST,
    payload,
  };
};

export const serviceRequestValidateComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_VALIDATE_COMPLETE,
    payload,
  };
};

export const serviceRequestValidateError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_VALIDATE_ERROR,
    payload,
  };
};

export const serviceRequestInitiateRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_INITIATE_REQUEST,
    payload,
  };
};

export const serviceRequestInitiateComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_INITIATE_COMPLETE,
    payload,
  };
};

export const serviceRequestInitiateError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_INITIATE_ERROR,
    payload,
  };
};

export const serviceRequestOtpRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_OTP_REQUEST,
    payload,
  };
};

export const serviceRequestOtpComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_OTP_COMPLETE,
    payload,
  };
};

export const serviceRequestOtpError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_OTP_ERROR,
    payload,
  };
};

export const serviceRequestResendOtpRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_RESEND_OTP_REQUEST,
    payload,
  };
};

export const serviceRequestResendOtpComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_RESEND_OTP_COMPLETE,
    payload,
  };
};

export const serviceRequestResendOtpError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_RESEND_OTP_ERROR,
    payload,
  };
};

export const serviceRequestFilterDataRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILTER_DATA_REQUEST,
    payload,
  };
};

export const serviceRequestFilterDataComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILTER_DATA_COMPLETE,
    payload,
  };
};

export const serviceRequestFilterDataError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILTER_DATA_ERROR,
    payload,
  };
};

export const serviceRequestDetailRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_DETAILS_REQUEST,
    payload,
  };
};

export const serviceRequestDetailComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_DETAILS_COMPLETE,
    payload,
  };
};

export const serviceRequestDetailError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_DETAILS_ERROR,
    payload,
  };
};

export const clearServiceRequestDetails = (payload) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST_DETAILS,
    payload,
  };
};

export const clearServiceRequestResponses = (payload) => {
  return {
    type: serviceRequestConstants.CLEAR_SERVICE_REQUEST_RESPONSES,
    payload,
  };
};

export const serviceRequestCancelRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_CANCEL_REQUEST,
    payload,
  };
};

export const serviceRequestCancelComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_CANCEL_COMPLETE,
    payload,
  };
};

export const serviceRequestCancelError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_CANCEL_ERROR,
    payload,
  };
};

export const serviceRequestFileUploadRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_UPLOAD_REQUEST,
    payload,
  };
};

export const serviceRequestFileUploadComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_UPLOAD_COMPLETE,
    payload,
  };
};

export const serviceRequestFileUploadError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_UPLOAD_ERROR,
    payload,
  };
};

export const serviceRequestFileDeleteRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_DELETE_REQUEST,
    payload,
  };
};

export const serviceRequestFileDeleteComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_DELETE_COMPLETE,
    payload,
  };
};

export const serviceRequestFileDeleteError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_DELETE_ERROR,
    payload,
  };
};

export const serviceRequestFileGetRequest = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_GET_REQUEST,
    payload,
  };
};

export const serviceRequestFileGetComplete = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_GET_COMPLETE,
    payload,
  };
};

export const serviceRequestFileGetError = (payload) => {
  return {
    type: serviceRequestConstants.SERVICE_REQUEST_FILE_GET_ERROR,
    payload,
  };
};
